module.exports = __webpack_public_path__ + "img/4_74.3c3a9206.png";